module.exports = __webpack_public_path__ + "img/s3tt.6e6d4921.svg";